/**
 * Created by aaikepae on 1/16/17.
 */
import React from "react"
import {connect} from "react-redux"
import WidgetLoader from "../../common/base/WidgetLoader"
import SubscriptionListener from './Subscription'
import ScopedHTML from './ScopedHTML'
import MyAccessPage from './MyAcessPage/MyAccessPage'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastProvider } from "../../common/base/ToastContext"
import SetSiteBreadCrum from "./SetSiteBreadCrum/SetSiteBreadCrum"
//import '../../../../pages/site/page/styles/impt.scss'

export class Site extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            route: ""
        };

        this.handleHashChange = this.handleHashChange.bind(this);
        this.rootRef = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("hashchange", this.handleHashChange);
    }

    handleHashChange() {
        console.log('hashchange1', window.location.hash);
        this.setState({ route: "update" });
    }

    componentWillUnmount() {
        window.removeEventListener("hashchange", this.handleHashChange);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let _container = window.PubHubSiteInstance.container;

        if (this.props.content && this.props.content.failed) {
            // <meta name="render:status_code" content="404">
            let meta = document.querySelector('meta[name="render:status_code"');
            if (meta) {
                meta.content = '404';
            } else {
                meta = document.createElement('meta');
                meta.name = 'render:status_code';
                meta.content = '404';
                document.head.append(meta);
            }

            const _event = new CustomEvent("contentError", {
                detail: {
                    data: {...this.props, container: this.rootRef.current}
                },
                bubbles: true,
                cancelable: true
            });
            _container.dispatchEvent(_event);

            return;
        }

        if (this.props.content && prevProps.content !== this.props.content) {
            const _event = new CustomEvent("load", {
                detail: {
                    data: {...this.props, content: this.props.content.data, container: this.rootRef.current}
                },
                bubbles: true,
                cancelable: true
            });
            _container.dispatchEvent(_event);
        }
    }
    handleRoute(path) {
        window.location.href = path;
    }
    render() {
        const {config, content, meta, components} = this.props;

        if (!config || !content || !meta) {
            return <span></span>
        }

       const content_el = config["scoped"]
           ? <ScopedHTML html={content.data} config={config} context={this}/>
           : <WidgetLoader html={content.data} config={config} context={this}/>


        const id = !meta["customizedStyle"] ? "pubhub-widgets" : meta["customizedStyle"];
        
        return <div id={id} className="pubhub-site-container" ref={this.rootRef}>
            <ToastContainer position="top-right" autoClose={3000} />
            <SubscriptionListener />
            <SetSiteBreadCrum config={config} meta={meta}/>
            {(content.failed ? (<div className="container dn-404"><a href="/">Go to Homepage</a></div>):
                    content_el)
                    
            }
        </div>
    }
}

function mapStateToProps(state, ownProps) {
    return {
        content: state.content,
        meta: state.meta,
        config: state.config
    };
}


export default connect(mapStateToProps, null, null, {forwardRef: true})(Site);
